import gettext from '@sdk/lang/gettext';

export default function getEmptyScreenTitle(readOnly: boolean, isCurrentUser: boolean): string {
  if (isCurrentUser && !readOnly) {
    return gettext(
      'No one can be available all the time. Set your availability here below to indicate when you are not.'
    );
  }

  if (isCurrentUser && readOnly) {
    return gettext(
      'No one can be available all the time. Ask your manager to update your availability to avoid being scheduled for when you are not.'
    );
  }

  if (!isCurrentUser && !readOnly) {
    return gettext(
      "No one can be available all the time. Update this employee's availability to avoid scheduling them for when they are not."
    );
  }

  return '';
}
